module.exports = __webpack_public_path__ + "img/success_red.f5bffaeb.svg";